import * as React from "react";
import Button from "@mui/material/Button";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { MyContext } from "../../pages/liveChat/index";
import Slide, { SlideProps } from "@mui/material/Slide";

// function SlideTransition() {
//   return <Slide {...props} direction="right" />;
// }

export default function Toast(props) {
  // const [open, setOpen] = React.useState(false);
  const { errorMessageState, setErrorMessageState } =
    React.useContext(MyContext);
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    // setOpen(false);
    setErrorMessageState(false);
  };

  return (
    <div>
      {/* <Button onClick={handleClick}>Open Snackbar</Button> */}
      <Snackbar
        open={errorMessageState}
        autoHideDuration={6000}
        onClose={handleClose}
        // TransitionComponent={SlideTransition}
      >
        <Alert
          onClose={handleClose}
          severity={props.severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {/* {props.shashank} */}
          {props.msg}
        </Alert>
      </Snackbar>
    </div>
  );
}
